<template>
  <div class="box-wrapper">
    <StimuliTitle
      title="Please enter your client assets for your primes. You can upload between 4 to 12 assets. For accurate results, ensure that your images are debranded, black and white (unless testing your brand’s colour palette) and isolated. We advise against combination assets."
    ></StimuliTitle>
    <ImageUpload
      v-for="(image, index) in fingerprint.clientDetails.assetDetails"
      :key="index"
      :image="image"
      :surveyID="fingerprint.surveyID"
      @set-image="setImage($event, index)"
      @delete="deleteImage(index)"
    ></ImageUpload>
    <div class="flex items-center gap-10">
      <a-button
        type="primary"
        @click="$emit('add-asset')"
        class="flex items-center gap-5"
        :disabled="isAssetLimitReached"
      >
        <icon-base
          :width="14"
          :height="14"
          :viewBox1="24"
          :viewBox2="24"
          iconName="plus"
          iconColor="#fff"
          ><icon-plus
        /></icon-base>
        Add asset</a-button
      >
      <span class="font-size-13 font-500"
        >{{ fingerprint.clientDetails.assetDetails.length }} of 12</span
      >
    </div>
  </div>
</template>

<script>
import StimuliTitle from "@/components/packTestSurvey/StimuliTitle.vue";
import ImageUpload from "@/components/brandFingerprint/ImageUpload.vue";
import IconBase from "@/components/general/IconBase.vue";
import IconPlus from "@/components/icons/IconPlus.vue";

export default {
  name: "ClientPrimes",
  components: { StimuliTitle, ImageUpload, IconBase, IconPlus },
  props: {
    fingerprint: Object,
  },
  data() {
    return {};
  },
  computed: {
    isAssetLimitReached() {
      const assetDetails = this.fingerprint.clientDetails.assetDetails;

      if (assetDetails.length >= 12) {
        return true;
      }

      return assetDetails.some(
        (asset) => asset.asset_description === "" || asset.upload_assets === ""
      );
    },
  },
  watch: {
    fingerprint: {
      handler() {
        this.validateInputs();
      },
      deep: true,
    },
  },
  methods: {
    setImage(imageURL, index) {
      this.fingerprint.clientDetails.assetDetails[index].upload_assets =
        imageURL;
    },
    validateInputs() {
      const filledImages = this.fingerprint.clientDetails.assetDetails.filter(
        (image) =>
          image.upload_assets.trim() !== "" &&
          image.asset_description.trim() !== ""
      );

      const hasEmptyFields = this.fingerprint.clientDetails.assetDetails.some(
        (image) =>
          image.upload_assets.trim() === "" ||
          image.asset_description.trim() === ""
      );
      const isNextDisabled = filledImages.length < 4 || hasEmptyFields;
      this.$emit("btn-next-disabled", isNextDisabled);
    },
    deleteImage(index) {
      let _this = this;
      const asset = this.fingerprint.clientDetails.assetDetails[index];

      const removeAssets = () => {
        _this.fingerprint.clientDetails.assetDetails.splice(index, 1);

        if (
          _this.fingerprint.competitorDetails &&
          Array.isArray(_this.fingerprint.competitorDetails.assetDetails) &&
          _this.fingerprint.competitorDetails.assetDetails[index]
        ) {
          _this.fingerprint.competitorDetails.assetDetails.splice(index, 1);
        }
      };

      if (asset.asset_description === "" || asset.upload_assets === "") {
        removeAssets();
      } else {
        this.$confirm({
          title: "Are you sure you want to delete this asset?",
          okText: "Delete",
          cancelText: " Cancel",
          onOk() {
            removeAssets();
          },
        });
      }
    },
  },
  mounted() {
    this.validateInputs();
  },
  created() {},
  activated() {},
};
</script>

<style lang="scss" scoped></style>
